import React, { useState,useEffect,useRef } from 'react';
import Footer from '../../../layout/Footer';
import ViewFestivalLeave from './ViewFestivalLeave';
import NewFestivalLeave from './NewFestivalLeave';
import { Container, Row, Col, Card, Form, Nav } from 'react-bootstrap';
import SimpleBarReact from "simplebar-react";
import Icon from '@mdi/react';
import { FestivalLeaveContxt } from './festivalLeaveContext';
import { FestivalLeaveProvider, useLeave } from './getfestivalLeave';
import { mdiMagnify, mdiPackageVariant, mdiPlus, mdiApplicationImport, mdiPrinterOutline } from '@mdi/js';

function FestivalLeave() {
    const { getFestivalLeave, fetchFestivalLeave } = useLeave();
    const [selectedFestivalId, setSelectedFestivalId] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [showFestival, setShowFestival] = useState(false);
    const [key, setKey] = useState(0);
    const isAdmin = Number(localStorage.getItem('admin'));

    useEffect(() => {
        fetchFestivalLeave();
    }, [selectedFestivalId]);

    const myStoreDetails = event => {
        document.getElementById("view-festival").classList.remove('d-none');
    }

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const filteredFestivalLeaveData = getFestivalLeave.filter((leave) =>
        leave.holiday_name.toLowerCase().includes(searchTerm.toLowerCase())
    );

  useEffect(() => {
        const sidebarItems = document.querySelectorAll(".left-link-item"); // Use querySelectorAll for better targeting
    
        // Loop over all sidebar items
        sidebarItems.forEach((item) => {
            item.addEventListener('click', function () {
                // Remove active class from all sidebar links
                const activeLink = document.querySelector(".left-link-item a.active");
                if (activeLink) activeLink.classList.remove("active");
    
                // Add active class to the clicked item
                const link = this.querySelector('a');
                if (link) link.classList.add('active');
    
                // Update selected vendor ID
                const vendorId = this.getAttribute('data-id');
                setSelectedFestivalId(vendorId);
                setShowFestival(false);

                // Trigger click on the "View Vendor" tab
                const viewVendorTab = document.getElementById("pills-view-festival-tab");
                if (viewVendorTab) {
                    viewVendorTab.click();  // Ensure the tab is switched programmatically
                }
    
            });
        });
    
        // Cleanup listeners on component unmount
        return () => {
            sidebarItems.forEach((item) => {
                item.removeEventListener('click', () => {});
            });
        };
    }, [filteredFestivalLeaveData]);

    useEffect(() => {
        if (getFestivalLeave.length > 0 && (!selectedFestivalId || !getFestivalLeave.some(c => c.id === selectedFestivalId))) {
            setSelectedFestivalId(getFestivalLeave[0].id);
        }
    }, [getFestivalLeave]);

    const handleNewFestivalSuccess = (newFestivalId) => {
        fetchFestivalLeave();
        setSelectedFestivalId(newFestivalId);
        setShowFestival(false);
        document.getElementById("pills-view-festival-tab")?.click();

    };

    const handleNewFestivalClick = () => {
        setShowFestival(true);
        setKey((prevKey) => prevKey + 1);
    };

    const searchInputRef = useRef(null);
    
    useEffect(() => {
        if (searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, []);
    
    return (
        <>
            <FestivalLeaveContxt.Provider value={selectedFestivalId}>
                <div className="page-wrapper">
                    <div className="page-content">
                        <Container>
                            <Row>
                                <Col>
                                    <Card>
                                        <Card.Body>
                                            <div className="d-md-flex justify-content-between align-items-center">
                                                <Form className="custom-form-width">
                                                    <div className="custom-search-bar">
                                                        <Icon
                                                            path={mdiMagnify}
                                                            size={1}
                                                            className="custom-search-input-icon"
                                                        />
                                                        <Form.Control
                                                            type="text"
                                                            placeholder={`Search festival from ${filteredFestivalLeaveData.length} festivals...`}
                                                            value={searchTerm}
                                                            onChange={handleSearchChange}
                                                            name='festivalSearch'
                                                            id='festivalSearch'
                                                            ref = {searchInputRef}
                                                        />
                                                    </div>
                                                </Form>
                                                <div className="custom-top-nav-tab mt-3 mt-md-0">
                                                    <ul className="nav nav-pills btn-list" id="pills-tab" role="tablist">
                                                          <li className="nav-item" role="presentation">
                                                            <button className="nav-link active" onClick={myStoreDetails} id="pills-view-festival-tab" data-bs-toggle="pill" data-bs-target="#pills-view-festtival" type="button" role="tab" aria-controls="pills-view-festival" aria-selected="true">
                                                                <Icon path={mdiPackageVariant} className="btn-icon me-1" />View Festival
                                                            </button>
                                                        </li>
                                                        {isAdmin == 1 &&(
                                                        <li className="nav-item" role="presentation">
                                                            <button
                                                                className={`nav-link ${showFestival ? 'active' : ''}`}
                                                                id="pills-new-festival-tab"
                                                                data-bs-toggle="pill"
                                                                data-bs-target="#pills-new-festival"
                                                                type="button"
                                                                role="tab"
                                                                aria-controls="pills-new-festival"
                                                                aria-selected="false"
                                                                onClick={handleNewFestivalClick}
                                                            >
                                                                <Icon path={mdiPlus} className="btn-icon me-1" />
                                                                Add Festival
                                                            </button>
                                                        </li>
                                                        )}
                                                    </ul>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>

                            <Row>
                                <Col lg={4} xxl={3}>
                                    <Card className="procust-left-list leftbar-list">
                                        <SimpleBarReact>
                                            <Card.Body>
                                                <div className="left-list-bar">
                                                    {filteredFestivalLeaveData.map((festival, i) => (
                                                        <Nav.Item
                                                            className="left-link-item"
                                                            key={i}
                                                            data-id={festival.id}
                                                            onClick={() => setSelectedFestivalId(festival.id)} // Update selected ID on click

                                                        >
                                                            <Nav.Link
                                                                className={
                                                                    festival.id === selectedFestivalId ? 'active' : ''
                                                                }
                                                            >
                                                                <h5 className="product-tab-title">
                                                                    {festival.holiday_name}
                                                                </h5>
                                                            </Nav.Link>
                                                        </Nav.Item>
                                                    ))}
                                                </div>
                                            </Card.Body>
                                        </SimpleBarReact>
                                    </Card>
                                </Col>
                                <Col lg={8} xxl={9}>
                                    <div className="tab-content" id="pills-tabContent">
                                        <div
                                            className={`tab-pane fade ${!showFestival ? 'show active' : ''}`}
                                            id="pills-view-festival"
                                            role="tabpanel"
                                            aria-labelledby="pills-view-festival-tab"
                                            tabIndex="0"
                                        >
                                            <ViewFestivalLeave
                                                setSelectedFestivalId={setSelectedFestivalId}
                                            />
                                        </div>
                                        <div
                                            className={`tab-pane fade ${showFestival ? 'show active' : ''}`}
                                            id="pills-new-festival"
                                            role="tabpanel"
                                            aria-labelledby="pills-new-festival-tab"
                                            tabIndex="0"
                                        >
                                            <NewFestivalLeave
                                                key={key}
                                                onSuccess={handleNewFestivalSuccess}
                                            />
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                    <Footer />
                </div>
            </FestivalLeaveContxt.Provider>
        </>
    );
}

export default function FestivalLeaveWithProvider() {
    return (
        <FestivalLeaveProvider>
            <FestivalLeave />
        </FestivalLeaveProvider>
    );
}